import styled, { css } from "styled-components";

export const StyledContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  background-color: #b9a893;
  min-height: 12.5rem;
  border-radius: 0.3125rem;
  color: #ebe3d8;
  box-shadow: 0.3125rem 0.3125rem 0.3125rem 0px rgba(0, 0, 0, 0.5);
  filter: drop-shadow(0.3125rem 0.3125rem 0.3125rem rgba(0, 0, 0, 0.3));
`;

export const StyledHeader = styled.div`
  height: 3.75rem;
  width: 100%;
  text-align: center;
  background-color: #4f382a;
  font-size: 2.3rem;
  line-height: 3.75rem;
  font-variant-numeric: lining-nums;
  text-transform: uppercase;
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
`;

export const StyledContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  padding: 1.3125rem 0.625rem 1.3125rem 0.625rem;
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
  font-optical-sizing: auto;
  /* font-weight: 400; */
`;

const hoverStyles = css`
  &:hover {
    color: #c97b74 !important;
  }
`;

export const StyledContentElem = styled.div<{
  isCursorPointer: boolean;
}>`
  height: 100%;
  width: 100%;
  display: flex;
  border-radius: 0.3125rem;
  background-color: #fbebd4;
  color: #8a7356 !important;
  min-height: 3.125rem;
  padding: 1.3125rem;
  box-sizing: border-box;
  margin-top: 0.625rem;
  cursor: ${(props) => (props.isCursorPointer ? "pointer" : "default")};

  ${({ isCursorPointer }) => isCursorPointer && hoverStyles}
`;

export const StyledButton = styled.div`
  width: 6.5625rem;
  height: 1.5625rem;
  font-size: 1.3rem;
  line-height: 1.5625rem;
  color: #2b1a13;
  padding: 0.3125rem;
  background-color: none;
  font-weight: 400;
  text-align: center;
  margin: 0.625rem;
  cursor: pointer;

  &:hover {
    color: #c97b74;
  }
`;
